<template>
  <div style="width: 100%">
    <v-autocomplete
        v-model="features"
        :items="searchResults"
        :loading="isLoading"
        item-text="desc"
        item-value="_id"
        :label="$t('features')"
        :placeholder="$t('startTypingToSearch')"
        @change="setResult()"
        deletable-chips
        multiple
        chips
        small-chips
        return-object
        :hint="(searchResults.length == 0 && showHint) ? $t('noResults'):''"
    ></v-autocomplete>
  </div>

</template>

<script>
import {mapActions} from 'vuex';

export default {
  name: "FeaturesAutocomplete",
  props: {
    model: {
      default: () => ''
    },
    index:{
      default: () => -1
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    features: [],
    searchResults: [],
    isLoading: false,
    search: null,
    showHint: false
  }),
  async created() {

    this.isLoading = true
    var result = await this.getItems()
    if (result.length > 0) {

      result.sort((a, b) => a.name.localeCompare(b.name)).filter

      result.map(x => this.searchResults.push({
        'desc': x.name,
        '_id': x._id
      }))


      if(this.model.length > 0){
        this.model.map(x => {
          var find = _.find(result,{'_id':x})
          if(find){
            this.features.push(find)
          }
        })
      }

    } else {
      this.showHint = true
    }
    this.isLoading = false
  },
  watch: {
  },
  methods:{
    ...mapActions({
      'getItems':'features/index'
    }),
    setResult() {
      if(this.index >= 0){

        if(this.features.length > 0){
          this.$emit('message',{'features':this.features, 'index':this.index})
        }else {
          this.searchResults = []
          this.$emit('message',{'features':'', 'index':this.index})
        }

      }else {

        if(this.features.length > 0){
          this.$emit('message',this.features)
        }else {
          this.$emit('message','')
        }

      }


    }
  }

}
</script>

<style scoped>

</style>